export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_q02_a.f6abf220.png";